import './App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Charts } from './pages/Charts';
import { Unsubscribe } from './pages/Unsubscribe';
import { Login } from './pages/Login';
import { AdminLayout } from './layouts/AdminLayout';
import { Settings } from './pages/Settings';
import { Admin } from './pages/Admin';
import ChartsAnalyticsBI from './pages/ChartsAnalyticsBI';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/" element={<Charts />} />
          <Route path="/admin">
            <Route path="login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="" element={<Settings />} />
              <Route path="settings" element={<Settings />} />
              <Route path="subscribers" element={<Admin />} />
              <Route path="charts-analytics-bi" element={<ChartsAnalyticsBI />} />
            </Route>
          </Route>
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
